const { formScheme } = require("./formScheme.js");
(function ($) {

    var alertIconSVG = "<svg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 15 15' xml:space='preserve'><g><path fill='#FF0000' d='M7.3,0.4c-3.9,0-7,3.2-7,7s3.2,7,7,7s7-3.2,7-7S11.1,0.4,7.3,0.4z M7.3,13c-3.1,0-5.5-2.5-5.5-5.5 s2.5-5.5,5.5-5.5c3.1,0,5.5,2.5,5.5,5.5S10.3,13,7.3,13z'/><rect x='6.5' y='3.6' fill='#FF0000' width='1.5' height='5.5'/><rect x='6.5' y='9.8' fill='#FF0000' width='1.5' height='1.5'/</g></svg>";

    function scrollToInput(container,target) {    
        var target = target;
        $(container).animate({ scrollTop: target }, 800);
    }

    function formatDate(e) {
        var string = $(e).val().replace(/\D/g, '');
        string = string.substring(0, 8);
        var length = string.length;
        var day = (parseInt(string.slice(0, 2)) < 32) ? string.slice(0, 2) : '00';
        var month = (parseInt(string.slice(2, 4)) < 13) ? string.slice(2, 4) : '00';
        var year = (string.slice(4, 8) < 2021) ? string.slice(4, 8) : '0000';
        if (length == 0) {
            string = string;
        } else if (length > 1 && length < 2) {
            string = string + "/";
        } else if (length > 2 && length < 5) {
            string = day + "/" + month;
        } else if (length > 4) {
            string = day + "/" + month + "/" + year;
        }
        $(e).val(string);
    }

    function formatNumber(e,length) {
        var string = $(e).val().replace(/\D/g, '');
        string = string.substring(0, length);

        
        $(e).val(string);
    }

    function formatEmail(e) {
        var string = $(e).val().toLowerCase();
        // string = string.substring(0, 10);
        $(e).val(string);
    }


    const scheme = formScheme;

    function validateInput(input) {

        let id = $(input).attr('name');
        let msg = $(input).attr('data-error');

        if (scheme.hasOwnProperty(id)) {

            if (scheme[id].type == 'email') {
                let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                if (!$(input).val().match(mailformat)) {
                    if (!$(input).hasClass("error")) {
                        $(input).addClass("error");
                        $(input).parent().addClass("error");
                        $(input).focus(function () {
                            $(input).siblings('small.msg').remove();
                        })
                        $(alertIconSVG).insertAfter(input).mouseenter(function () {
                            $("<small class='msg'>" + msg + "</small>").insertAfter(input);
                        }).mouseleave(function () {
                            $(input).siblings('small.msg').remove();
                        });
                    }
                    return { error: 1, inputID: input };
                }

            }
            if(scheme[id].type == 'boolean'){
                if (!$(input).is(':checked')){
                    if (!$(input).hasClass("error")) {
                        $(input).addClass("error");
                        $(input).parent().addClass("error");
                        $(input).focus(function () {
                            $(input).siblings('small.msg').remove();
                        })
                    }
                    
                    return { error: 1, inputID: input };
                }
            }
            if (scheme[id].type == 'string' || scheme[id].type == 'number' || scheme[id].type == 'date' || scheme[id].type == 'date_time' || scheme[id].type == 'select') {
                if ($(input).val().length < scheme[id].length) {
                    if (!$(input).hasClass("error")) {
                        $(input).addClass("error");
                        $(input).parent().addClass("error");
                        $(input).focus(function () {
                            $(input).siblings('small.msg').remove();
                        })
                        $(alertIconSVG).insertAfter(input).mouseenter(function () {
                            $("<small class='msg'>" + msg + "</small>").insertAfter(input);
                        }).mouseleave(function () {
                            $(input).siblings('small.msg').remove();
                        });
                    }
                    return { error: 1, inputID: input };
                }
            }

        }

    }

    function validateForm(form, scroll,container) {

        var form = form;
        var errors = [];
        var inputsId = [];

        $("small.msg").remove();

        $(form).find("input,textarea,select,fieldset").each(function () {

            if(validateInput(this)){
                errors.push(validateInput(this).error);
                inputsId.push(validateInput(this).inputID);
            }

        });
        error = errors.length;
        if (error > 0) {
            $('input,textarea,select').blur();
            if (scroll) {
                // 
                if(container){
                    if($(inputsId[0]).is('input')){
                        var target = $(inputsId[0]).parent().position().top;
                    } else {
                        var target = $(inputsId[0]).position().top;
                    }
                    
                } else {
                    var target = $(inputsId[0]).offset().top;
                }
                var container = (container)?container:'html ,body';
                scrollToInput(container,target);
            }
            return false;
        } else {
            return true;
        }
    }



    module.exports = {
        validateForm: validateForm,
        formatDate: formatDate,
        formatNumber: formatNumber,
        formatEmail:formatEmail
    }

})(jQuery)